module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Blood Before Dawn")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "acknowledgments"
    }
  }, [_c('p', {
    staticClass: "ct1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_vm._v("ACKNOWLEDGMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("To Caleb Guard, my editor, for his patience, understanding and professionalism and to Andrea Vande Vorde for her eye for detail.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I would also like to thank Jane Knuth of the The Knuth Agency for being a particularly thoughtful early reader and editor and to Teeja Meier, my wife, for her faith in me and for her love.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a63f90aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter03.vue
// module id = 72
// module chunks = 0